import { NotifyHelper } from "../../../helpers/toast";
import { eBoMonActionsObj } from "../../action-types/category/IBoMonActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const boMonActions = {
  ...generateActions(eBoMonActionsObj, "BO_MON"),
  ...generateActionForKey(eBoMonActionsObj, "BO_MON", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eBoMonActionsObj, "BO_MON", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eBoMonActionsObj, "BO_MON", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eBoMonActionsObj, "BO_MON", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
